<template>
  <a-modal
    title="选择客户"
    style="top: 20px;"
    :width="1000"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
  <a-card :bordered="false" :bodyStyle="{ padding: 0}">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="8">
          <a-col :md="6" :sm="24">
            <a-form-item>
              <a-tree-select
                v-model="queryParam.catId"
                placeholder='请选择客户类别'
                treeDefaultExpandAll
                :treeData="categoryData"
              >
              </a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item>
              <a-input placeholder="输入客户编号/名称" v-model="queryParam.kw"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select placeholder="请选择" default-value="" v-model="queryParam.status">
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="active">启用</a-select-option>
                <a-select-option value="deleted">禁用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="tableSearch">查询</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table
      size="middle"
      ref="table"
      rowKey="id"
      :pageSize=10
      :columns="columns"
      :data="loadData"
      bordered
      :rowSelection="options.rowSelection"
      :alert="options.alert"
    >
      <span slot="status" slot-scope="text, record">
        <a-switch disabled checkedChildren="启用" unCheckedChildren="禁用" defaultChecked v-if="record.status == 'active'" @change="statusChange($event, record)"/>
        <a-switch disabled checkedChildren="启用" unCheckedChildren="禁用" v-else  @change="statusChange($event, record)"/>
      </span>
    </s-table>
  </a-card>
  </a-modal>
</template>
<script>
import STable from '@/components/table/'
import { getCustomerList } from '@/api/customer'
import { getCategoryCustomer } from '@/api/category'
export default {
  name: 'CustomerModal',
  components: {
    STable
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      selectrow: {},

      // 查询参数
      queryParam: {
        kw: '',
        catId: '0',
        status: ''
      },
      categoryData: null,
      // 表头
      columns: [
        {
          title: '客户类别',
          dataIndex: 'category.name',
          className: 'text-center'
        },
        {
          title: '客户编号',
          dataIndex: 'locationNo',
          className: 'text-center'
        },
        {
          title: '客户名称',
          dataIndex: 'name',
          className: 'text-center'
        },
        {
          title: '联系人',
          dataIndex: 'contactName',
          className: 'text-center'
        },
        {
          title: '手机',
          dataIndex: 'contactPhone',
          className: 'text-center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          className: 'text-center',
          scopedSlots: { customRender: 'status' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getCustomerList(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.result
          })
      },

      selectedRowKeys: [],
      selectedRows: [],
      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange,
          type: 'radio'
        }
      }
    }
  },
  created () {
    this.loadCategory()
  },
  methods: {
    reloadTable () {
      this.$refs.table.refresh(true)
    },
    tableSearch () {
      this.$refs.table.refresh(true)
    },
    resetTableSearch () {
      this.queryParam = {
        kw: '',
        catId: '0',
        status: ''
      }
      this.reloadTable()
    },
    loadCategory () {
      getCategoryCustomer({ tree: true })
        .then(res => {
          this.categoryData = res.result
        })
    },
    handleOk () {
      this.$emit('handleOk', this.selectedRows)
      this.$refs.table.clearSelected()
    },
    handleCancel () {
      this.$emit('handleCancel')
      this.$refs.table.clearSelected()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    }
  },
  watch: {
  }
}
</script>
